import { themeGet } from "@styled-system/theme-get";
import * as styledSystem from "styled-system";
const { get: getKey } = styledSystem;

export const makeThemeGet = (theme) => (key) =>
  themeGet(key, getKey(theme, key));
